module.exports = __webpack_public_path__ + "static/1075aa9c2ad3f14753ed007620109590.png";